import { useAtomValue } from 'jotai'

import { session } from './auth'

export function useSession() {
  const value = useAtomValue(session)
  return [value]
}
